<template>
  <a-spin :indicator="indicator" />
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue'

import { h } from 'vue'
export default {
  name: 'LoadingCircle',
  components: {},
  props: {
    fontSize: {
      type: Number,
      default: 18
    }
  },
  computed: {
    indicator() {
      return h(LoadingOutlined, {
        style: {
          fontSize: `${this.fontSize}px`
        },
        spin: true
      })
    }
  }
}
</script>

<style lang="scss"></style>
